<template>
<div>
<div class="pop_title">유관 사업</div>
<div class="pop_table04 scroll">
    <table class="tb-list01" summary="유관 사업">
        <caption>유관 사업목록</caption>
        <colgroup>
            <col style="width:18%">
            <col style="width:50%">
            <col style="width:32%">
        </colgroup>
        <thead>
        <tr>
            <th>구분</th>
            <th>사업명</th>
            <th>주소</th>
        </tr>
        </thead>
        <tbody>
         <tr v-for="governanceFoundInfo in relevantBizList" :key="governanceFoundInfo.amnDataSqno">
            <td>{{diagName}}</td>
            <td class="alignL"><div class="text-ellipsis">{{ governanceFoundInfo.val2 }}</div></td>
            <td>{{ governanceFoundInfo.val6 }}</td>
        </tr>
        </tbody>
    </table>
</div>
</div>
</template>

<script>

export default {
    name: 'governanceRelevantBizFoundInfoList',
    props: {
        governanceFoundInfo: {
            type: Object,
            required: true
        },
        diagName: ''
    },
    computed: {
        relevantBizList() {
            return this.$store.getters.getGovernanceFoundList;
        }
    },
    watch: {
        governanceFoundInfo: {
            immediate: true,
            handler: function(newVal, oldVal) {
                if(typeof this.governanceFoundInfo.amnDataSqno !== 'undefined') {
                    this.$store.dispatch('FETCH_GOVERNANCE_FOUND_LIST');
                }
            }
        }
    },
}
</script>

<style scoped>

</style>